import React, { useState } from 'react';
import { Link } from '../../StateContext';
import EditIcon from '@mui/icons-material/Edit';
import {
    Modal,
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { boxStyle } from '../../Pages/Projects/styles';
import { editLinkWeightCall } from '../../Services/APICalls/apicalls';
import { MechanicHourValue } from '../../Services/types';
import { StateContext } from '../../StateContext';
import { IContextData } from '../../../App';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    link: Link;
}

const EditAllWeeksWeight = (props: IProps) => {
    const { setLoginData } = React.useContext<IContextData>(StateContext);
    const { t } = useLanguage();
    const [weight, setWeight] = useState<number>(100);
    const [open, setOpen] = useState(false);

    const submitHandler = (e?: React.FormEvent) => {
        e?.preventDefault();
        editLinkWeightCall(props.link.id, weight, setLoginData);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Tooltip title={t('setAllWeeksPercentage')} arrow>
                <div className='cursor-pointer'>
                    <EditIcon fontSize='small' onClick={() => setOpen(true)} />
                </div>
            </Tooltip>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <form
                        action='#'
                        className='flex flex-col items-center gap-3'
                        onSubmit={submitHandler}
                    >
                        <p style={{ width: '220px', textAlign: 'center' }}>
                            {t('setAllWeeksPercentageWarning')}
                        </p>
                        <div>
                            <FormControl style={{ width: '220px' }}>
                                <InputLabel id='all-weeks-weight-select-label'>
                                    {t('percentToCount')}
                                </InputLabel>
                                <Select
                                    label={t('percentToCount')}
                                    labelId='all-weeks-weight-select-label'
                                    id='all-weeks-weight-select'
                                    value={weight}
                                    onChange={(x) => setWeight(x.target.value as number)}
                                >
                                    {MechanicHourValue.map((type) => (
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <button style={{ width: '220px' }}>{t('edit')}</button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default EditAllWeeksWeight;
